<p
  class="agent-field-note"
  [class.agent-field-note--dark]="surface() === 'dark'"
  [class.agent-field-note--light]="surface() === 'light'"
  role="note"
>
  @switch (variant()) {
    @case ('data-schema') {
      Describes the shape of the answer agent should return. Use <strong>Format JSON</strong> to
      tidy spacing; it doesn’t change the meaning.
    }
    @case ('prompt') {
      Keep it aligned with your <strong>data schema</strong> above so answers match what your page
      expects.
    }
    @case ('ui-template') {
      Describes the HTML layout of the answer agent should return. Pull values in with placeholders
      like
      <code>{{ '{' }}data.productName{{ '}' }}</code
      >—use simple dotted paths, not scripts. If the agent returns a <strong>plain list</strong> of
      results, this block is shown once per item. For a list inside a single result, a placeholder
      like <code>{{ '{' }}data.includedProducts{{ '}' }}</code> can show a short bullet list when
      entries look like products (names or titles). Prefer simple, safe HTML—no embedded scripts or
      click handlers.
    }
  }
</p>
